import { CodeBlock } from "@mittwald/flow-remote-react-components";
import { Link } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { InlineCode } from "@mittwald/flow-remote-react-components";
import {
  defaultErrorComponentMap,
  ErrorMap,
  getSupportEmail,
} from "@wiesinghilker/extension-lib-frontend";

const SupportEmailLink = ({ error }: { error: Error }) => {
  const supportEmail = getSupportEmail();
  return (
    <Link
      href={`mailto:${supportEmail}?subject=${encodeURIComponent("Fehler in der Extension")}&body=${encodeURIComponent(`Folgender Fehler ist bei der Benutzung der Extension aufgetreten:\n\n${error.stack ?? error.message}\n\nDer Fehler ist auf folgender Seite aufgetreten:\n\n${window.location.href}`)}`}
    >
      {supportEmail}
    </Link>
  );
};

export const errorMap: ErrorMap = {
  ...defaultErrorComponentMap,
  SavingAppInstallationIniError: (error: Error) => (
    <>
      <Text>
        Wir konnten deine Konfiguration nicht speichern. Folgende Fehlermeldung
        wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Bitte überprüfe, ob du aus dieser Fehlermeldung das Problem ableiten
        kannst. Falls nicht, wende dich bitte an unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  SavingProjectIniError: (error: Error) => (
    <>
      <Text>
        Wir konnten deine Konfiguration nicht speichern. Folgende Fehlermeldung
        wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Bitte überprüfe, ob du aus dieser Fehlermeldung das Problem ableiten
        kannst. Falls nicht, wende dich bitte an unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  LoadProjectError: (error: Error) => (
    <>
      <Text>
        Wir konnten dein Projekt nicht aus dem mStudio abrufen. Folgende
        Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Möglicherweise handelt es sich dabei nur um ein temporäres Problem.
        Probiere es einfach in einigen Augenblicken nochmal.
      </Text>
      <Link href={window.location.href}>Nochmal versuchen</Link>
      <Text>
        Wenn sich das Problem nicht von selbst lösen lässt, wende dich bitte an
        unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  LoadAppPHPSettingsError: (error: Error) => (
    <>
      <Text>
        Wir konnten die PHP-Einstellungen deiner App nicht laden. Folgende
        Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Häufig ist das Problem eine ungültige <InlineCode>.user.ini</InlineCode>
        -Datei in deinem App-Verzeichnis. Bitte überprüfe die Syntax und lösche
        die Datei ggf. einfach.
      </Text>
      <Link href={window.location.href}>Nochmal versuchen</Link>
      <Text>
        Wenn sich das Problem nicht lösen lässt, wende dich bitte an unseren
        Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  LoadProjectPHPSettingsError: (error: Error) => (
    <>
      <Text>
        Wir konnten die PHP-Einstellungen deines Projektes nicht laden. Folgende
        Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Häufig ist das Problem eine ungültige <InlineCode>php.ini</InlineCode>{" "}
        in deinem Projekt. Bitte überprüfe die Syntax und leere die Datei ggf.
        einfach. Du findest die Datei unter dem Pfad{" "}
        <InlineCode>/etc/php/php.ini</InlineCode>
      </Text>
      <Link href={window.location.href}>Nochmal versuchen</Link>
      <Text>
        Wenn sich das Problem nicht lösen lässt, wende dich bitte an unseren
        Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  LoadProjectPHPStatisticsError: (error: Error) => (
    <>
      <Text>
        Wir konnten die Cache-Statistiken deiner App nicht laden. Folgende
        Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Bitte überprüfe, ob du aus dieser Fehlermeldung das Problem ableiten
        kannst. Falls nicht, wende dich bitte an unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
};
